import { useState, useEffect } from "react";
import { Outlet, Navigate, useLocation } from "react-router-dom";
import { Sidebar, MobileNavSheet } from "@/components/shell/Sidebar";
import { TopBar } from "@/components/shell/TopBar";
import { CommandPalette } from "@/components/shell/CommandPalette";
import { LeadNotificationConfigBanner } from "@/components/shell/LeadNotificationConfigBanner";
import { useBillingState } from "@/store/useBillingStore";

export function AppShell() {
  const location = useLocation();
  const billingState = useBillingState();
  const [mobileNavOpen, setMobileNavOpen] = useState(false);

  // Keep mobile drawer from lingering after resize to desktop.
  useEffect(() => {
    const mq = window.matchMedia("(min-width: 1024px)");
    const onChange = (e) => {
      if (e.matches) setMobileNavOpen(false);
    };
    mq.addEventListener("change", onChange);
    return () => mq.removeEventListener("change", onChange);
  }, []);

  // Phase 12 — Trial expired gate. Allow /upgrade, public, and /demo routes (handled outside shell).
  if (billingState === "trial-expired" && !location.pathname.startsWith("/upgrade")) {
    return <Navigate to="/upgrade?reason=trial-expired" replace />;
  }

  return (
    <div className="flex h-dvh w-full overflow-hidden bg-slate-50 text-slate-900">
      <Sidebar />
      <MobileNavSheet open={mobileNavOpen} onOpenChange={setMobileNavOpen} />
      <div className="flex-1 min-w-0 flex flex-col">
        <TopBar onOpenMobileNav={() => setMobileNavOpen(true)} />
        <LeadNotificationConfigBanner />
        <main className="flex flex-1 min-h-0 min-w-0 flex-col overflow-hidden bg-slate-50" data-testid="app-main">
          <div className="flex flex-1 min-h-0 min-w-0 flex-col overflow-hidden">
            <Outlet />
          </div>
        </main>
      </div>
      <CommandPalette />
    </div>
  );
}
